"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M16 3H4c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z"];
//# sourceMappingURL=stop.js.map